type Props = {
  size?: string;
};

export default function ProductNotFoundIcon({ size = "120" }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="product not found icon"
    >
      <rect width="120" height="120" rx="60" fill="#ECEDFE" />
      <path
        d="M73.8004 82.2002C73.8004 76.2355 68.9651 71.4002 63.0004 71.4002C58.7599 71.4002 55.0903 73.8441 53.323 77.4002C52.6044 78.8461 52.2004 80.476 52.2004 82.2002C52.2004 83.4625 52.4169 84.6742 52.8149 85.8002C54.2975 89.9949 58.298 93.0002 63.0004 93.0002C67.7028 93.0002 71.7032 89.9949 73.1858 85.8002C73.5838 84.6742 73.8004 83.4625 73.8004 82.2002Z"
        fill="white"
      />
      <path
        d="M41.4004 82.2002H52.2004C52.2004 80.476 52.6044 78.8461 53.323 77.4002H41.4004C40.0749 77.4002 39.0004 78.4747 39.0004 79.8002C39.0004 81.1257 40.0749 82.2002 41.4004 82.2002Z"
        fill="#797FD2"
      />
      <path
        d="M79.8004 34.2002H74.4004C77.0514 34.2002 79.2004 36.3492 79.2004 39.0002V81.0002C79.2004 83.6512 77.0514 85.8002 74.4004 85.8002H79.8004C82.4514 85.8002 84.6004 83.6512 84.6004 81.0002V39.0002C84.6004 36.3492 82.4514 34.2002 79.8004 34.2002Z"
        fill="#D5D7F7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M74.4004 34.2002H40.2004C37.5494 34.2002 35.4004 36.3492 35.4004 39.0002V81.0002C35.4004 83.6512 37.5494 85.8002 40.2004 85.8002H52.8149C52.4169 84.6742 52.2004 83.4625 52.2004 82.2002H41.4004C40.0749 82.2002 39.0004 81.1257 39.0004 79.8002C39.0004 78.4747 40.0749 77.4002 41.4004 77.4002H53.323C55.0903 73.8441 58.7599 71.4002 63.0004 71.4002C68.9651 71.4002 73.8004 76.2355 73.8004 82.2002C73.8004 83.4625 73.5838 84.6742 73.1858 85.8002H74.4004C77.0514 85.8002 79.2004 83.6512 79.2004 81.0002V39.0002C79.2004 36.3492 77.0514 34.2002 74.4004 34.2002Z"
        fill="#ADB1EB"
      />
      <path
        d="M79.8004 85.8002C82.4514 85.8002 84.6004 83.6512 84.6004 81.0002V39.0002C84.6004 36.3492 82.4514 34.2002 79.8004 34.2002M79.8004 85.8002H73.1858M79.8004 85.8002H74.4004M79.8004 34.2002H40.2004M79.8004 34.2002H74.4004M40.2004 34.2002C37.5494 34.2002 35.4004 36.3492 35.4004 39.0002V81.0002C35.4004 83.6512 37.5494 85.8002 40.2004 85.8002H52.8149M40.2004 34.2002H74.4004M74.4004 85.8002C77.0514 85.8002 79.2004 83.6512 79.2004 81.0002V39.0002C79.2004 36.3492 77.0514 34.2002 74.4004 34.2002M74.4004 85.8002H73.1858M52.2004 82.2002H41.4004C40.0749 82.2002 39.0004 81.1257 39.0004 79.8002C39.0004 78.4747 40.0749 77.4002 41.4004 77.4002H53.323M52.2004 82.2002C52.2004 80.476 52.6044 78.8461 53.323 77.4002M52.2004 82.2002C52.2004 83.4625 52.4169 84.6742 52.8149 85.8002M39.6004 62.4002H63.0004M69.6004 62.4002H75.0004M39.6004 67.8002H52.8004M39.6004 72.0002H48.0004M53.323 77.4002C55.0903 73.8441 58.7599 71.4002 63.0004 71.4002C68.9651 71.4002 73.8004 76.2355 73.8004 82.2002C73.8004 83.4625 73.5838 84.6742 73.1858 85.8002M73.1858 85.8002C71.7032 89.9949 67.7028 93.0002 63.0004 93.0002C58.298 93.0002 54.2975 89.9949 52.8149 85.8002"
        stroke="#0F134E"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.8791 37.2002H73.7217C75.0906 37.2002 76.2004 38.3419 76.2004 39.7502V55.0502C76.2004 56.4585 75.0906 57.6002 73.7217 57.6002H40.8791C39.5101 57.6002 38.4004 56.4585 38.4004 55.0502V39.7502C38.4004 38.3419 39.5101 37.2002 40.8791 37.2002Z"
        fill="white"
      />
      <path
        d="M61.6719 79.0634C61.9579 78.5868 62.37 78.3817 62.8074 78.3204C63.2813 78.2541 63.7246 78.3692 63.9222 78.4752C64.1422 78.5932 64.3928 78.9205 64.4296 79.3249C64.46 79.659 64.3473 80.1202 63.7012 80.5505C63.1624 80.9093 62.6543 81.2698 62.3728 81.8453C62.1041 82.3945 62.1001 83.0319 62.1001 83.7007C62.1001 84.1978 62.5031 84.6007 63.0001 84.6007C63.4972 84.6007 63.9001 84.1978 63.9001 83.7007C63.9001 82.9339 63.9376 82.7428 63.9897 82.6362C64.0289 82.556 64.1207 82.4337 64.699 82.0486C65.8529 81.2801 66.3167 80.2021 66.2222 79.162C66.1341 78.1923 65.5584 77.3102 64.773 76.889C64.2272 76.5962 63.3969 76.4204 62.5578 76.5378C61.6824 76.6604 60.7424 77.1138 60.1284 78.1375C59.8727 78.5637 60.0109 79.1165 60.4372 79.3722C60.8634 79.6279 61.4162 79.4897 61.6719 79.0634Z"
        fill="#0F134E"
      />
      <path
        d="M62.2759 85.9762C62.6759 85.5762 63.3244 85.5762 63.7244 85.9762C64.1244 86.3762 64.1244 87.0247 63.7244 87.4247C63.3244 87.8247 62.6759 87.8247 62.2759 87.4247C61.8759 87.0247 61.8759 86.3762 62.2759 85.9762Z"
        fill="#0F134E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.2 42.5996C59.5255 42.5996 60.6 43.6741 60.6 44.9996V49.7996C60.6 51.1251 59.5255 52.1996 58.2 52.1996H61.8C63.1255 52.1996 64.2 51.1251 64.2 49.7996V44.9996C64.2 43.6741 63.1255 42.5996 61.8 42.5996H58.2Z"
        fill="#D5D7F7"
      />
      <path
        d="M58.2 42.5996H53.4C52.0745 42.5996 51 43.6741 51 44.9996V49.7996C51 51.1251 52.0745 52.1996 53.4 52.1996H58.2C59.5255 52.1996 60.6 51.1251 60.6 49.7996V44.9996C60.6 43.6741 59.5255 42.5996 58.2 42.5996Z"
        fill="#797FD2"
      />
      <path
        d="M53.4 52.1996H61.8M53.4 52.1996C52.0745 52.1996 51 51.1251 51 49.7996V44.9996C51 43.6741 52.0745 42.5996 53.4 42.5996M53.4 52.1996H58.2M61.8 52.1996C63.1255 52.1996 64.2 51.1251 64.2 49.7996V44.9996C64.2 43.6741 63.1255 42.5996 61.8 42.5996M61.8 52.1996H58.2M61.8 42.5996H53.4M61.8 42.5996H58.2M53.4 42.5996H58.2M58.2 52.1996C59.5255 52.1996 60.6 51.1251 60.6 49.7996V44.9996C60.6 43.6741 59.5255 42.5996 58.2 42.5996"
        stroke="#0F134E"
        stroke-width="1.5"
      />
    </svg>
  );
}
